import './Menu.css'
import React, { useState } from 'react'
import Sidebar from '../../Components/SideBar/index'
import ScrollToTop from '../../Components/ScrollToTop'
import Index2 from '../../Components/Navbar2/index2'
import Footer from '../../Components/Footer/Footer'
import InfoSection3 from '../../Components/Infosection3/Index3'
import { homeObjOne3 } from '../../Components/Infosection3/Data3'

const MenuInd = () => {
  const [isOpen, setIsOpen] = useState(false)
        
       const toggle = () => {
        setIsOpen(!isOpen)
       }
  return (
    <>
      <ScrollToTop />
      <div className='HeroContainer_menu'>
         <Sidebar isOpen={isOpen} toggle={toggle}/>
        <div className='Hero_menu'>
          <Index2 toggle={toggle}/>
        </div>
      </div>
      <InfoSection3 {...homeObjOne3}/>
      <div className='menu_con'>
        <div className='menu_title'>
          Vår Meny
        </div>
        <div className='pris'>
          För mer info kontakta gärna 
          <br />
          076 413 08 53
          <br />
          cateringbyprestig@gmail.com
        </div>
      </div>
      <br />
      <br /><br />
      <div className='menu'>
        <div className='menu_pic'>
          <div className='grid-container'>
            <div className='card_con'>
                <div className='wrapper'>
                <br /><br />
                    <div className='card_area'>
                        <div className='card'>
                        <div className='meny_title'>
                            KALLA INDISKA DELIKATESSER
                        </div><br /><br />
                        <div className='menu_mat'>
                            Kachumber – fräsch sallad med tomat, gurka, rödlök, koriander & lime.
                            <br /><br />
                            Mango - & myntasallad med chili & färska örter.
                            <br /><br />
                            Raita med gurka, mynta & rostade spiskummin.
                            <br /><br />
                            Chana Chaat – kikärtor med tomat, rödlök, koriander & tamarind.
                            <br /><br />
                            Tandoori - marinerad kycklingsallad med färska örter.
                            <br /><br />
                            Picklade grönsaker & indiska chutneys.
                            <br /><br />
                            Papadum med mango chutney & mynta-yoghurt.
                        </div>
                        </div>
                        <div className='card'>
                        <div className='meny_title'>
                            INDISKA SMAKBITAR
                      </div><br /><br />
                      <div className='menu_mat'>
                        Samosa med potatis, ärtor & aromatiska kryddor.
                        <br /><br />
                        Chicken Tikka-bitar med mynta & koriander.
                        <br /><br />
                        Pakora med grönsaker & koriander.
                        <br /><br />
                        Papadum med tamarind- & myntachutney.
                      </div> 
                    </div>              
                    <div className='card'>
                        <div className='meny_title'>
                         VARMA INDISKA SPECIALITETER
                        </div><br /><br />
                    <div className='menu_mat'>
                        Butter Chicken - 
                        Mör kyckling i krämig tomat- och currysås med milda indiska kryddor.
                        <br /><br />
                        Rogan Josh - 
                        Mört nötkött i aromatisk sås med kardemumma, kanel, ingefära & indiska kryddor.
                        <br /><br />
                        Chicken Tikka - 
                        Tandoori-marinerad kyckling med yoghurt, citron & klassiska kryddor.
                        <br /><br />
                        Paneer Tikka Masala - 
                        Grillad paneer i mustig tomat- och currysås med paprika & färska örter.
                    </div>
                    </div>
                    <div className='card'>
                    <div className='meny_title'>
                        INDISKT RIS & TILLBEHÖR
                        </div><br /><br />
                        <div className='menu_mat'>
                            Saffrans- & basmatiris med rostade nötter.
                            <br /><br />
                            Vegetable Biryani med saffran, grönsaker & färska örter.
                            <br /><br />
                            Dal Makhani – krämig linsgryta med indiska kryddor.
                            <br /><br />
                            Jeera Rice med spiskummin & färska örter.
                            <br /><br />
                            Rostade grönsaker med garam masala.
                        </div>
                        </div>
                        <div className='card'>
                        <div className='meny_title'>
                            NDISKT BRÖD
                        </div><br /><br />
                        <div className='menu_mat'>
                            Naan.
                            <br /><br />
                            Garlic Naan.
                            <br /><br />
                            Roti.
                            <br /><br />
                            Papadum.
                        </div>
                        </div>
                        <div className='card'>
                            <div className='meny_title'>
                                CHUTNEYS & SÅSER
                            </div><br /><br />
                        <div className='menu_mat'>
                            Mango chutney.
                            <br /><br />
                            Mint & korianderchutney.
                            <br /><br />
                            Tamarindchutney.
                            <br /><br />
                            Raita.
                            <br /><br />
                            Mild indisk chilisås.
                        </div>
                        </div>
                        <div className='card'>
                            <div className='meny_title'>
                                 INDISKA DESSERTER
                            </div><br /><br />
                            <div className='menu_mat'>
                                Gulab Jamun – varma små degbollar i aromatisk sirap.
                                <br /><br />
                                Mango - & kardemummapannacotta.
                                <br /><br />
                                Kheer – krämig indisk rispudding med kardemumma & pistage.
                                <br /><br />
                                Gajar Halwa – indisk morotsdessert med kardemumma & nötter.
                                <br /><br />
                                Färsk mango, ananas & vindruvor.
                                <br /><br />
                            </div>
                        </div>
                  </div>             
                </div>
              </div>
            </div>
          </div>
        </div>
      <Footer />
    </>
  )
}

export default MenuInd